module.exports = __webpack_public_path__ + "static/meda-provider7-7a9938b03dc26186272e39bf187afb79.png";